import styled from 'styled-components'

import { primary, transparency } from 'styles/Colors'

// table overwrite styles
export const Container = styled(({ height, ...props }) => <div {...props} />)`
  overflow-y: auto;
  & > div {
    & > div {
      display: block;
    }
  }
  & [class$='Table'] {
    max-height: 30vh;
    height: auto;
    background-color: #fcfcfc;
  }
  & [class$='TableBody'] {
    min-width: max-content;
    max-height: ${({ height }) => height};
    transition: all ease-out 250ms;
    background-color: #fcfcfc;
    padding-bottom: 2rem;
    margin-top: 0;
  }
  & [class$='TableHeadRow'] {
    border: none;
    min-height: 17px;
    background-color: #fcfcfc;
    & [class$='TableCol'] {
      padding: 0;
      &:last-child {
        text-align: left;
        padding-right: 1rem;
        & > div {
          padding-left: 0;
          justify-content: flex-end;
        }
      }
      & > div {
        color: #EB7C0C;
        font-family: coresanscr85;
        font-size: 0.8125rem;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        pointer-events: none;
        padding-left: 0.75rem;
        & > span {
          margin-left: 8px;
          color: ${primary + transparency[70]};
        }
      }
    }
  }
  & [class$='TableRow'] {
    margin-top: 1rem;
    min-height: 80px !important;
    height: auto !important;
    background: transparent;
    align-items: stretch !important;
    border-bottom: 1px solid #e8e8e8;
    font-family: coresanscr45;
    cursor: pointer;
    width: calc(100% - 115px);
    display: flex !important;
    flex-direction: row !important;
    &:first-child {
      margin-top: 0.5rem;
    }
    & [class$='TableCell'] {
      font-size: 0.9375rem;
      width: 100px;
      min-height: 80px !important;
      height: auto !important;
      padding: 0;
      align-items: stretch !important;
      justify-content: flex-start;
      line-height: 1.5;
      word-wrap: break-word;
      overflow-wrap: break-word;
      border: none;
      display: flex !important;
      flex: 1 !important;
      &:not(:first-child) {
        border-left: 1px solid #e8e8e8;
      }
    }
  }
  
  /* Override selected row styling to match row height */
  & [class$='TableRow'][style*='rgba(108, 91, 255, 0.1)'] {
    height: auto !important;
    min-height: 80px !important;
    align-items: stretch !important;
    
    & [class$='TableCell'] {
      height: auto !important;
      min-height: 80px !important;
      align-items: stretch !important;
    }
  }
`
